import { render, staticRenderFns } from "./female.vue?vue&type=template&id=5477e5e0&scoped=true&"
var script = {}
import style0 from "./female.vue?vue&type=style&index=0&id=5477e5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477e5e0",
  null
  
)

export default component.exports